/* global google */
const loadEventGoogleMaps = {
	el: {
		body: document.querySelector('body'),
		map: document.querySelector('.js-map'),
		asideItemCardInfo: document.querySelectorAll('.js-aside-item'),
		buttonWithMapLocation: document.querySelectorAll('.js-button-with-map-location')
	},

	fxHandleCreateScriptTag(el) {
		// Check if map element exists
		if (!el) return

		// save key in variable
		const googleMapsKey = this.el.body.getAttribute('data-google-map-key')

		// Create the script tag, set the appropriate attributes
		let script = document.createElement('script')

		// Set the source of the script
		script.src = `https://maps.googleapis.com/maps/api/js?${googleMapsKey && 'key='}${googleMapsKey}&callback=initMap`
		script.async = true

		// Attach your callback function to the `window` object
		window.initMap = () => {
			// it has to be called this.el.map in order to not create a new script tag on each page load that has js.map and other class for use google maps instance
			this.fxLoadMap(this.el.map)
		}

		// Save footer element
		const footer = document.querySelector('.footer')

		// Append the script tag to the right after footer
		footer.parentNode.insertBefore(script, footer.nextSibling)
	},

	fxLoadMap(el) {
		// Variables that we can set in the mapOptions
		const mapZoomControl = el.dataset.mapZoomControl && JSON.parse(el.dataset.mapZoomControl),
			mapFullScreenControl = el.dataset.mapFullScreenControl && JSON.parse(el.dataset.mapFullScreenControl),
			mapStreetViewControl = el.dataset.mapStreetViewControl && JSON.parse(el.dataset.mapStreetViewControl),
			mapScaleControl = el.dataset.mapScaleControl && JSON.parse(el.dataset.mapScaleControl),
			mapRotateControl = el.dataset.mapRotateControl && JSON.parse(el.dataset.mapRotateControl),
			mapScrollWheel = el.dataset.mapScrollWheel && JSON.parse(el.dataset.mapScrollWheel),
			mapLatitude = el.dataset.mapLatitude && Number(el.dataset.mapLatitude),
			mapLongitude = el.dataset.mapLongitude && Number(el.dataset.mapLongitude)

		// Set options for each map
		const mapOptions = {
			center: {
				lat: mapLatitude ? mapLatitude : 0,
				lng: mapLongitude ? mapLongitude : 0
			},
			zoom: 11,
			disableDefaultUI: true,
			scrollwheel: mapScrollWheel ? true : false,
			zoomControl: mapZoomControl ? true : false,
			scaleControl: mapScaleControl ? true : false,
			streetViewControl: mapStreetViewControl ? true : false,
			rotateControl: mapRotateControl ? true : false,
			fullscreenControl: mapFullScreenControl ? true : false
		}

		// Create the map
		const map = new google.maps.Map(el, mapOptions)

		// return map
		return map
	},

	fxUpdateHrefButtonOverMap(el) {

		// Get map
		const findMap = this.el.map

		// get attributes of map - latitude, longitude
		const mapLatitude = findMap && findMap.getAttribute('data-map-latitude')
		const mapLongitude = findMap && findMap.getAttribute('data-map-longitude')

		// set href to button
		el.href = `https://www.google.com/maps/dir//${mapLatitude},${mapLongitude}`
	},

	events() {
		// Responsible for creating the script tag and inserting it after the footer - this way we can load map only when is needed
		this.fxHandleCreateScriptTag(this.el.map)

		// Update the href attribute of the buttons with the map location
		this.el.buttonWithMapLocation.forEach(el => this.fxUpdateHrefButtonOverMap(el))
	},

	init() {
		this.events()
	}
}

loadEventGoogleMaps.init()